// A quiet base map keeps the app's table markers easy to find.
// Businesses keep their icons and names so users can create a table there.
export const mapStyles = [
    { elementType: 'geometry', stylers: [{ color: '#f1eee7' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: '#73766c' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#f1eee7' }, { weight: 3 }] },
    { featureType: 'landscape.man_made', elementType: 'geometry', stylers: [{ color: '#e7e4dc' }] },
    { featureType: 'landscape.natural', elementType: 'geometry', stylers: [{ color: '#f1eee7' }] },
    { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#e7e4dc' }] },
    { featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'on' }] },
    { featureType: 'poi.business', stylers: [{ visibility: 'on' }] },
    { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#d2e5cc' }] },
    { featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [{ color: '#6c8269' }] },
    { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
    { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: '#dcded5' }] },
    { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#85867d' }] },
    { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#faf8f2' }] },
    { featureType: 'road.local', elementType: 'labels', stylers: [{ visibility: 'simplified' }] },
    { featureType: 'transit', stylers: [{ visibility: 'off' }] },
    { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#aedbe1' }] },
    { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#608d94' }] },
];
